import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AuthContextProvider from "./contexts/AuthContext";
import {BrowserRouter} from "react-router-dom";
import 'antd/dist/antd.css';
import 'react-notifications/lib/notifications.css';
import './StrondaDarkGlobal.css';
import './StrondaDarkFixes.css';
import './StrondaMobileFinal.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <AuthContextProvider>
          <BrowserRouter>
              <App/>
          </BrowserRouter>
      </AuthContextProvider>
  </React.StrictMode>
);

reportWebVitals();

// Registra o PWA da Stronda Music Telemetria sem interferir nas chamadas da API.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch((error) => {
      console.error("Falha ao registrar o app da Stronda Music Telemetria:", error);
    });
  });
}
